var map = {
	"./arrows/chevron-bottom.svg": 41237,
	"./arrows/chevron-left.svg": 45730,
	"./arrows/chevron-right.svg": 27077,
	"./arrows/chevron-top.svg": 24057,
	"./arrows/drag-arrow-horizontal.svg": 12629,
	"./arrows/drag-arrow.svg": 66649,
	"./arrows/exchange-arrows.svg": 6610,
	"./arrows/long-arrow-left.svg": 75776,
	"./arrows/long-arrow-right-bold.svg": 37285,
	"./arrows/long-arrow-right.svg": 14876,
	"./arrows/share.svg": 45325,
	"./channels/channel-email.svg": 35834,
	"./channels/channel-link.svg": 66701,
	"./channels/channel-push.svg": 71634,
	"./channels/channel-repeats.svg": 65396,
	"./channels/channel-sms.svg": 50319,
	"./channels/channel-telegram.svg": 80108,
	"./channels/channel-viber.svg": 4867,
	"./chart/chart-column.svg": 11844,
	"./chart/chart-pie.svg": 88055,
	"./client/client-added.svg": 71076,
	"./client/client-birthday.svg": 81035,
	"./client/client-fields.svg": 17292,
	"./client/client-filials.svg": 28716,
	"./client/client-last-order.svg": 55726,
	"./client/client-ltv.svg": 52715,
	"./client/client-tags.svg": 88062,
	"./client/client-updated.svg": 92675,
	"./gender/gender-female.svg": 14962,
	"./gender/gender-male.svg": 71694,
	"./history/history-compensations.svg": 57348,
	"./history/history-events.svg": 90423,
	"./history/history-messages.svg": 29074,
	"./history/history-orders.svg": 45202,
	"./history/history-reviews.svg": 95523,
	"./history/history.svg": 87372,
	"./input/input-checkbox.svg": 75992,
	"./input/input-except.svg": 82568,
	"./input/input-multi-line.svg": 64134,
	"./input/input-radio.svg": 55150,
	"./input/input-single-line.svg": 11859,
	"./input/input-text.svg": 34235,
	"./mailings-actions/restart.svg": 20840,
	"./mailings-actions/start.svg": 53956,
	"./mailings-actions/stop.svg": 29999,
	"./map/map-marker-google.svg": 25202,
	"./map/map-marker-yandex.svg": 21304,
	"./mark/correct-mark.svg": 53001,
	"./mark/incorrect-mark.svg": 43840,
	"./mark/part-correct-mark.svg": 83657,
	"./media/blank.svg": 10466,
	"./media/image-bold.svg": 9099,
	"./media/image-light.svg": 12868,
	"./media/image.svg": 23891,
	"./media/text.svg": 81435,
	"./media/video-image.svg": 40294,
	"./media/video-light.svg": 74521,
	"./media/video-play-button.svg": 29464,
	"./media/video.svg": 79775,
	"./person/user-bg.svg": 39502,
	"./person/user-circle.svg": 7146,
	"./person/user-light.svg": 61266,
	"./person/user.svg": 35973,
	"./poll/poll-archive.svg": 44256,
	"./poll/poll-copy.svg": 47920,
	"./poll/poll-donor.svg": 45451,
	"./poll/poll-export.svg": 99427,
	"./poll/poll-move.svg": 10902,
	"./poll/poll-points.svg": 13966,
	"./poll/poll-publish.svg": 86984,
	"./poll/poll-remove.svg": 31073,
	"./poll/poll-start.svg": 97711,
	"./poll/poll-stop.svg": 85367,
	"./poll/target-link.svg": 90729,
	"./poll/test-mode.svg": 96266,
	"./positioning/positioning-bottom.svg": 1274,
	"./positioning/positioning-center.svg": 24743,
	"./positioning/positioning-top.svg": 16249,
	"./problems/problem-less.svg": 16274,
	"./problems/problem-stop.svg": 32621,
	"./problems/problem-time-bold.svg": 24481,
	"./problems/problem-time.svg": 48423,
	"./question-types/question-address.svg": 65674,
	"./question-types/question-card-sorting.svg": 14350,
	"./question-types/question-classifier.svg": 91276,
	"./question-types/question-date.svg": 33722,
	"./question-types/question-diff.svg": 85105,
	"./question-types/question-distribution-scale.svg": 60516,
	"./question-types/question-end.svg": 66879,
	"./question-types/question-file.svg": 5019,
	"./question-types/question-filials.svg": 7698,
	"./question-types/question-five-second-test.svg": 74427,
	"./question-types/question-gallery.svg": 35825,
	"./question-types/question-inter.svg": 75694,
	"./question-types/question-matrix-3d.svg": 23938,
	"./question-types/question-matrix.svg": 82380,
	"./question-types/question-media-variants.svg": 70052,
	"./question-types/question-nps.svg": 90926,
	"./question-types/question-priority.svg": 19437,
	"./question-types/question-quiz.svg": 44444,
	"./question-types/question-rate-1.svg": 62467,
	"./question-types/question-rate.svg": 64355,
	"./question-types/question-rating.svg": 74671,
	"./question-types/question-scale.svg": 47378,
	"./question-types/question-smile.svg": 80145,
	"./question-types/question-star-variants.svg": 95460,
	"./question-types/question-stars-1.svg": 55133,
	"./question-types/question-stars.svg": 50260,
	"./question-types/question-start.svg": 74433,
	"./question-types/question-text-input.svg": 19184,
	"./question-types/question-text.svg": 93150,
	"./question-types/question-upload.svg": 13582,
	"./question-types/question-variants.svg": 22742,
	"./question-types/question-vars.svg": 38816,
	"./question/question-close.svg": 55166,
	"./rating/rating-1.svg": 97662,
	"./rating/rating-2.svg": 75853,
	"./rating/rating-3.svg": 27093,
	"./rating/rating-4.svg": 23764,
	"./rating/rating-5.svg": 76000,
	"./rating/rating-critics.svg": 19834,
	"./rating/rating-face-1.svg": 26162,
	"./rating/rating-face-2.svg": 88598,
	"./rating/rating-face-3.svg": 81109,
	"./rating/rating-face-4.svg": 35650,
	"./rating/rating-face-5.svg": 60088,
	"./rating/rating-heart-1.svg": 6584,
	"./rating/rating-heart-5.svg": 27742,
	"./rating/rating-like-1.svg": 19282,
	"./rating/rating-like-5.svg": 48058,
	"./rating/rating-promoters.svg": 27886,
	"./rating/rating-smile-1.svg": 71246,
	"./rating/rating-smile-5.svg": 59483,
	"./rating/rating-star-empty.svg": 85193,
	"./rating/rating-star-fill.svg": 58634,
	"./rating/rating-star-half.svg": 73246,
	"./rating/rating-star.svg": 22422,
	"./review/review-created.svg": 29415,
	"./review/review-elapsed.svg": 70522,
	"./review/review-feedback.svg": 26677,
	"./review/review-passed.svg": 67867,
	"./review/review-poll.svg": 80780,
	"./review/review-processed.svg": 7957,
	"./review/review-request.svg": 36468,
	"./sections/section-answers.svg": 49761,
	"./sections/section-polls.svg": 56171,
	"./service/actions.svg": 55962,
	"./service/aim.svg": 51633,
	"./service/alarm.svg": 17601,
	"./service/api.svg": 71052,
	"./service/arrow-right.svg": 56858,
	"./service/bin-clear.svg": 52148,
	"./service/bin.svg": 79426,
	"./service/briefcase.svg": 22465,
	"./service/burger.svg": 33160,
	"./service/calendar.svg": 80390,
	"./service/check-bold.svg": 5862,
	"./service/check.svg": 84767,
	"./service/clip-bold.svg": 84169,
	"./service/clip.svg": 72561,
	"./service/clipboard.svg": 81761,
	"./service/comment.svg": 5632,
	"./service/complaint-2.svg": 54289,
	"./service/complaint.svg": 58505,
	"./service/contact-point.svg": 63612,
	"./service/copy.svg": 89279,
	"./service/dictionary-connection.svg": 20092,
	"./service/download.svg": 54235,
	"./service/dynamics.svg": 52411,
	"./service/ellipsis.svg": 37586,
	"./service/empty-star.svg": 35972,
	"./service/envelope.svg": 48589,
	"./service/excel.svg": 60338,
	"./service/exclamation-circle-filled.svg": 22653,
	"./service/exclamation-circle-light.svg": 75162,
	"./service/exclamation-circle.svg": 6118,
	"./service/expand.svg": 48291,
	"./service/eye-light.svg": 39039,
	"./service/eye-slash-light.svg": 46516,
	"./service/eye-slash.svg": 73149,
	"./service/eye.svg": 48970,
	"./service/folder-big.svg": 51913,
	"./service/folder.svg": 30036,
	"./service/four-circles.svg": 87238,
	"./service/home.svg": 746,
	"./service/info-circle.svg": 14441,
	"./service/link.svg": 17472,
	"./service/list-check.svg": 5310,
	"./service/load.svg": 1674,
	"./service/lock-closed.svg": 80452,
	"./service/lock-open.svg": 58954,
	"./service/lock-shuffle.svg": 42807,
	"./service/lock.svg": 94547,
	"./service/logic.svg": 69852,
	"./service/logout.svg": 97198,
	"./service/matrix-sort-inverse.svg": 78419,
	"./service/matrix-sort.svg": 11303,
	"./service/message-filled-stroke.svg": 4306,
	"./service/message-filled.svg": 93766,
	"./service/message.svg": 55616,
	"./service/minus.svg": 49652,
	"./service/outer-link.svg": 15101,
	"./service/pencil.svg": 71990,
	"./service/phone.svg": 37475,
	"./service/plus.svg": 85204,
	"./service/print.svg": 15558,
	"./service/qr.svg": 29524,
	"./service/repeat.svg": 41896,
	"./service/save.svg": 97012,
	"./service/search.svg": 62018,
	"./service/settings-warning.svg": 96272,
	"./service/settings.svg": 29687,
	"./service/shuffle.svg": 48041,
	"./service/star.svg": 94992,
	"./service/target.svg": 77711,
	"./service/time.svg": 48492,
	"./service/times-bold.svg": 71826,
	"./service/times.svg": 26122,
	"./service/translate.svg": 56342,
	"./service/update.svg": 92300,
	"./service/upload.svg": 48170,
	"./service/wavy-circle-2.svg": 4841,
	"./service/wavy-circle-3.svg": 30166,
	"./service/wavy-circle.svg": 11536,
	"./social/fb.svg": 74177,
	"./social/instagram.svg": 18872,
	"./social/vk.svg": 16890,
	"./table/filter.svg": 45299,
	"./table/filters-settings.svg": 23327,
	"./table/sort.svg": 1974,
	"./text/text-bold.svg": 44151,
	"./text/text-italic.svg": 24499,
	"./types/type-auto.svg": 9824,
	"./types/type-manual.svg": 71706,
	"./view-modes/view-mode-cards.svg": 94713,
	"./view-modes/view-mode-kanban.svg": 80606,
	"./view-modes/view-mode-list.svg": 47066,
	"./viewport/viewport-desktop.svg": 69968,
	"./viewport/viewport-helloboard-desktop.svg": 82681,
	"./viewport/viewport-helloboard-mobile.svg": 22263,
	"./viewport/viewport-mobile.svg": 14786,
	"./viewport/viewport-pagestop-desktop.svg": 50259,
	"./viewport/viewport-pagestop-mobile.svg": 3886,
	"./viewport/viewport-trade.svg": 27013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33101;